import React, { useState, useRef, useEffect } from 'react'
import { useForm, useFieldArray, Controller } from "react-hook-form";
import { useParams, Link } from 'react-router-dom';
import { ErrorMessage } from "@hookform/error-message"
import axios from 'axios'
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import Select from 'react-select';
import { customSelectStylesForJobForm } from './utils/selectStyles';
import { Position, Industry, Tag, Prefecture, City, SelectOptionType, Job } from '../types/jobTypes';
import { useCityOptions } from './utils/usePrefectureAndCityOptions';

// 受け取るpropsの型定義
type Content = {
  isEditMode: boolean
}

export default function JobForm({isEditMode} :Content) {
  // ReactHookFormの初期化
  const { register, handleSubmit, reset, setValue, control, formState: {errors} } = useForm<Job>(
    { defaultValues: {
      position: [{ id: null }], // useFieldArrayを使用して、初期状態で1つのフォームを表示させておくため
    },}
  )
  // 値セット（後で消します）
  function setJob() {
    setValue('company_name', '株式会社aby');
    setValue('phone_number', '09012345678');
    setValue('closing_date', '2025-04-30');
    setValue('catch_copy', '総支給245000円外国人を積極的に採用中');
    setValue('position', [{id: 1}]);
    setValue('industry_id', 1);
    setValue('salary', '月給 ¥245,000 ～');
    // setValue('area_id', 1);
    setValue('japanese_level', 'n3');
    setValue('appeal_point', '【仕事内容】機械設計：3Dでの設計経電気設計：使用ツール：InventorCR-8000、CR-5000、Capital、OrCAD、AutoCAD Electrical、各種EDAツール、三菱シーケンサ、オムロンPLCな生産技術：工程設計、設備・ロボットの導入・立ち上げ、工程改善品質系：品質管理、品質保証の経その他、テストエンジニア、半導体関連の経験者');
    setValue('employment_type', 'full_time');
    setValue('visa_type', 'tech');
    setValue('working_hours', '機械・電気・電子エンジニア月給 ¥210,000 ～ ¥530,000勤務時間09:00 AM ~ 06:00 PM週5日から5日まで1日2時間から');
    setValue('probation_period', '90日変動なし');
    setValue('postal_code', '1234567');
    setValue('prefecture_id', 1);
    setValue('city_id', 1);
    setValue('address', '五反田1丁目27-5');
    setValue('building_name', 'VORT五反田7F');
    setValue('transportation_fee', '全額支給');
    setValue('holidays', 'シフト制 完全週休2日');
    setValue('salary_increase_criteria','経験有無');
    setValue('insurance', '健康保険');
    setValue('benefits', '・時間外手当あり・有給休暇あり・昇給あり');
  }

  // ページ遷移用の関数
  const navigate = useNavigate();

  // エラーメッセージの状態管理
  let errorMessages : string[] = []
  // フォーム送信状態の管理
  const [isSubmited, setIsSubmited] = useState(false)
  // 募集職種選択のセレクトボックスに入れる内容管理
  const [positions, setPositions] = useState<Position[]>([])
  // 業種選択のセレクトボックスに入れる内容管理
  const [industries, setIndustries] = useState<Industry[]>([])
  // タグ選択のセレクトボックスに入れる内容管理
  const [tags, setTags] = useState<Tag[]>([])
  // 地域選択のセレクトボックスに入れる内容管理
  // const [areas, setAreas] = useState<Area[]>([])
  // 雇用形態の状態管理
  const [employmentType, setEmploymentType] = useState('full_time');
  // job_positionsテーブルのデータを管理する
  const [jobPositionIds, setJobPositionIds] = useState<{id: number, position_id: number}[]>([])
  // job_tagsテーブルのデータを管理する
  const [jobTagIds, setJobTagIds] = useState<{id: number, tag_id: number}[]>([])
  // パンくずのための求人会社名を状態管理
  const [companyName, setCompanyName] = useState<string>('')

  const [currentJob, setCurrentJob] = useState<Job>()

  const {
		cityOption,
		cityOptions,
		loadingCities,
		defaultCityOption,
		prefectureOption,
		prefectureOptions,
		setCityOption,
		setCityOptions,
		setPrefectureOption,
		updateCityOptions,
		initializePrefectureOptions,
		setInitialPrefectureAndCityOption,
  } = useCityOptions()

  // 現在のページのidを取得
  const query = useParams().id

  // ページ読み込み時とSubmit押下時にAPIから関連テーブルの情報を取得
  useEffect(() => {
    // APIから全ての値を取得し選択肢をセットするところは最初に完了している必要あるためPromiseで定義
    const promise1 = new Promise((resolve) => {
      axios.get('/api/v1/positions')
      .then (res => {
        setPositions(JSON.parse(res.data.positions));
        resolve('positions取得完了')
      })
    })
    const promise2 = new Promise((resolve) => {
      axios.get('/api/v1/industries')
      .then (res => {
        setIndustries(JSON.parse(res.data.industries));
        resolve('industries取得完了')
      })
    })
    const promise3 = new Promise((resolve) => {
      axios.get('/api/v1/tags')
      .then (res => {
        setTags(JSON.parse(res.data.tags));
        resolve('tags取得完了')
      })
    })
    // const promise4 = new Promise((resolve) => {
    //   axios.get('/api/v1/areas')
    //   .then (res => {
    //     setAreas(JSON.parse(res.data.areas));
    //     resolve('area取得完了')
    //   })
    // })
    const promise4 = new Promise((resolve) => {
      axios.get('/api/v1/prefectures')
      .then (res => {
        const resPrefectures: Prefecture[] = JSON.parse(res.data.prefectures)
        initializePrefectureOptions(resPrefectures)
        resolve('prefectures取得完了')
      })
    })

    // 4つのPromiseが完了したらこのコードを実行する
    Promise.all([promise1, promise2, promise3, promise4])
    .then(() => {
      setJobData()
    })
    .catch(() => {
      alert('サーバーとの通信に失敗しました。');
    })

    // 上のPromiseが全て完了した際に行う処理をひとまとめに定数として定義
    const setJobData = () => {
      if (isEditMode) {
        // ページ読み込み時とid変更時と送信ボタン押下時
        axios.get(`/api/v1/jobs/${query}/edit`) // idを渡し、jobsの情報を取得
        .then (res => {
          const job_data = res.data.job;
          // job_positionsテーブルのデータを取得
          const position_ids = res.data.position_ids;
          // job_tagsテーブルのデータを取得
          const tag_ids = res.data.tag_ids;
          // job_positionsデータを管理
          setJobPositionIds(position_ids);
          // job_tagsのidを管理
          setJobTagIds(tag_ids);
          setCurrentJob(job_data);
          reset({
            pr_flag: job_data.pr_flag,
            display_company_name_flag: job_data.display_company_name_flag,
            company_name: job_data.company_name,
            phone_number: job_data.phone_number,
            closing_date: job_data.closing_date,
            catch_copy: job_data.catch_copy,
            position: position_ids,
            industry_id: job_data.industry_id,
            salary: job_data.salary,
            // area_id: job_data.area_id,
            japanese_level: job_data.japanese_level,
            tag: tag_ids,
            appeal_point: job_data.appeal_point,
            employment_type: job_data.employment_type,
            visa_type: job_data.visa_type,
            working_hours: job_data.working_hours,
            probation_period: job_data.probation_period,
            postal_code: job_data.postal_code,
            prefecture_id: job_data.prefecture_id,
            city_id: job_data.city_id,
            address: job_data.address,
            building_name: job_data.building_name,
            transportation_fee: job_data.transportation_fee,
            holidays: job_data.holidays,
            overtime: job_data.overtime,
            salary_increase_criteria: job_data.salary_increase_criteria,
            insurance: job_data.insurance,
            benefits: job_data.benefits,
            residence_permit: job_data.residence_permit,
            interview_method: job_data.interview_method,
            work_environment_age: job_data.work_environment_age,
            work_environment_gender: job_data.work_environment_gender,
            work_environment_foreign_ratio: job_data.work_environment_foreign_ratio,
            work_environment_language: job_data.work_environment_language,
            work_environment_hiring_exp: job_data.work_environment_hiring_exp,
            work_environment_japanese_freq: job_data.work_environment_japanese_freq,
          })
          // setValueするためにデータを成形
          const positionIds = position_ids.map((position: {id: number, position_id: number}) => ({id: position.position_id}));
          setValue('position', positionIds);
          // setValueするためにデータを成形
          const tagIds = tag_ids.map((tag: {id: number, tag_id: number}) => String(tag.tag_id));
          setValue('tag', tagIds);
          // 写真データのプレビューのみセット
          setImagePath(job_data.company_image.url);
          // パンくずのための会社名セット
          setCompanyName(job_data.company_name);
          setEmploymentType(job_data.employment_type);
        })
        .catch (err => {
          console.log(err);
          alert("データの取得に失敗しました。");
        });
      }
    }
  }, [query, isSubmited]);

  // 前述のuseEffect時にPromise4でsetPrefecturesしたprefecturesを使用する必要があるため別のuseEffectを指定
  useEffect( () => {
    if (currentJob) {
      setInitialPrefectureAndCityOption(isEditMode, currentJob)
    }
  }, [currentJob])

  // 募集職種では useFieldArray を使って動的にフォームを追加・削除
  const { fields, append, remove } = useFieldArray({
    name: "position", // 入力フォームの属性名
    control
  });

  // hiddenになっているfileのinputタグの生DOMをuseRefで保持
  const inputRef = useRef<HTMLInputElement | null>(null);
  // プレビュー用の画像管理
  const [imagePath, setImagePath] = useState('') // 初期画像
  // ファイルがアップロードされたときプレビューを表示
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.currentTarget?.files && e.currentTarget.files[0]) {
      const targetFile = e.currentTarget.files[0] // React.ChangeEvent<HTMLInputElement>よりファイルを取得
      setImagePath(window.URL.createObjectURL(targetFile)) // オブジェクトURLを生成し、useState()を更新
      setValue('company_image', [targetFile]); // フォームの値としても登録 (これがないとReact Hook Form側でファイルが認識されない)
    }
  }
  // カスタマイズしたボタンをクリックすることで、hiddenのアップロードボタンをクリックする
  const uploadClick = () => {
    if (inputRef.current) { // null でないことを確認してから実行
      inputRef.current.click();
    }
  }

  // Railsへ送信するデータをFormDataでJSONの許容する形に成形
  const CreateFormData = (data: Job) => {
    const sendData = new FormData()
    sendData.append('job[pr_flag]', String(data.pr_flag))
    sendData.append('job[display_company_name_flag]', String(data.display_company_name_flag))
    sendData.append('job[company_name]', data.company_name)
    sendData.append('job[phone_number]', data.phone_number)
    sendData.append('job[closing_date]', data.closing_date)
    sendData.append('job[catch_copy]', data.catch_copy)
    sendData.append('job[industry_id]', String(data.industry_id))
    sendData.append('job[salary]', data.salary)
    // sendData.append('job[area_id]', String(data.area_id))
    sendData.append('job[japanese_level]', data.japanese_level)
    sendData.append('job[appeal_point]', data.appeal_point)
    sendData.append('job[employment_type]', data.employment_type)
    sendData.append('job[visa_type]', data.visa_type)
    sendData.append('job[working_hours]', data.working_hours)
    sendData.append('job[probation_period]', data.probation_period)
    sendData.append('job[postal_code]', data.postal_code)
    sendData.append('job[prefecture_id]', String(data.prefecture_id))
    sendData.append('job[city_id]', String(data.city_id))
    sendData.append('job[address]', data.address)
    sendData.append('job[building_name]', data.building_name)
    sendData.append('job[transportation_fee]', data.transportation_fee)
    sendData.append('job[holidays]', data.holidays)
    sendData.append('job[overtime]', data.overtime)
    sendData.append('job[salary_increase_criteria]', data.salary_increase_criteria)
    sendData.append('job[insurance]', data.insurance)
    sendData.append('job[benefits]', data.benefits)
    sendData.append('job[residence_permit]', data.residence_permit)
    sendData.append('job[interview_method]', data.interview_method)
    sendData.append('job[work_environment_age]', data.work_environment_age)
    sendData.append('job[work_environment_gender]', data.work_environment_gender)
    sendData.append('job[work_environment_foreign_ratio]', data.work_environment_foreign_ratio)
    sendData.append('job[work_environment_language]', data.work_environment_language)
    sendData.append('job[work_environment_hiring_exp]', data.work_environment_hiring_exp)
    sendData.append('job[work_environment_japanese_freq]', data.work_environment_japanese_freq)
    // 企業用掲載写真のデータ生成
    if (data.company_image && data.company_image[0]) {
      sendData.append('job[company_image]', data.company_image[0])
    }

    // 募集職種のデータ生成
    const newPositionIds = data.position.map(p => p.id);
    let paramsPositionLength = jobPositionIds.length
    if (paramsPositionLength > 0) {
      // 既存のjob_positionsのデータを処理
      jobPositionIds.forEach((job_position, index) =>
        { if (newPositionIds.includes(job_position.position_id)) {
            // 編集時に選択されたままのデータの場合は、そのままパラメータへ追加
            sendData.append(`job[job_positions_attributes][${index}][id]`, String(job_position.id))
            sendData.append(`job[job_positions_attributes][${index}][position_id]`, String(job_position.position_id))
          } else {
            // 編集時に未選択のデータの場合はdestroy処理をパラメータへ追加
            sendData.append(`job[job_positions_attributes][${index}][id]`, String(job_position.id))
            sendData.append(`job[job_positions_attributes][${index}][_destroy]`, '1')
          }
        }
      )
      // 新たに選択されたpositionの処理
      newPositionIds.forEach((newId) => {
        { if (!jobPositionIds.some(job=> job.position_id === newId)) {
            sendData.append(`job[job_positions_attributes][${paramsPositionLength}][position_id]`, String(newId))
            paramsPositionLength += 1;
          }
        }
      })
    } else {
      data.position.forEach((position, index) =>
        sendData.append(
          `job[job_positions_attributes][${index}][position_id]`, String(position.id)
        )
      )
    }

    // タグのデータ生成
    const newTagIds = data.tag;
    let paramsTagLength = jobTagIds.length;
    if (newTagIds && paramsTagLength > 0) {
      // 既存のjob_tagsのデータを処理
      jobTagIds.forEach((job_tag, index) =>
        { if (newTagIds.includes(String(job_tag.tag_id))) {
            // 編集時に選択されたままのデータの場合は、そのままパラメータへ追加
            sendData.append(`job[job_tags_attributes][${index}][id]`, String(job_tag.id))
            sendData.append(`job[job_tags_attributes][${index}][tag_id]`, String(job_tag.tag_id))
          } else {
            // 編集時に未選択のデータの場合はdestroy処理をパラメータへ追加
            sendData.append(`job[job_tags_attributes][${index}][id]`, String(job_tag.id))
            sendData.append(`job[job_tags_attributes][${index}][_destroy]`, '1')
          }
        }
      )
      // 新たに選択されたtagの処理
      newTagIds.forEach((newId) => {
        { if (!jobTagIds.some(job=> String(job.tag_id) === newId)) {
            sendData.append(`job[job_tags_attributes][${paramsTagLength}][tag_id]`, String(newId))
            paramsTagLength += 1;
          }
        }
      })
    } else if (newTagIds === null && paramsTagLength > 0) {
      // 既存のjob_tagsのデータを処理
      jobTagIds.forEach((job_tag, index) => {
        // 全てdestroy処理をパラメータへ追加
        sendData.append(`job[job_tags_attributes][${index}][id]`, String(job_tag.id))
        sendData.append(`job[job_tags_attributes][${index}][_destroy]`, '1')
      })
    } else if (newTagIds && paramsTagLength === 0) {
      newTagIds.forEach((tag, index) =>
        sendData.append(`job[job_tags_attributes][${index}][tag_id]`, tag)
      )
    }

    return sendData
  }

  return (
    <div className='admin-bg__color'>
      <div className='breadcrumb'>
        {isEditMode ? (
          <ul>
            <li><a href='/admins/jobs'>求人一覧</a></li>
            <li>{companyName}</li>
          </ul>
        ) : (
          <ul>
            <li>求人新規作成</li>
          </ul>
        )}
      </div>
      <div className='admin-card'>
        <div className='admin-card__container'>
          <form
            className='d-flex flex-column admin-form'
            onFocus={() => setIsSubmited(false)}
            onSubmit={handleSubmit(async (data) => {
              const sendData = await CreateFormData(data)
              const config = {
                headers: {
                  'content-type': 'multipart/form-data'
                }
              }
              { isEditMode ? (
                // 編集時のデータ送信
                axios.put(`/api/v1/jobs/${query}`, sendData)
                .then(res => {
                  const valid_flag = JSON.parse(res.data.valid_flag)
                  // 編集に成功
                  if (valid_flag) {
                    console.log(res.data.data)
                    toast.success('求人の編集に成功しました。')
                    navigate('/admins/jobs');
                  // 編集に失敗（バリデーションエラー）
                  } else {
                    JSON.parse(res.data.errors, function (key, value) {
                      if(key) {
                        if(!Array.isArray(value)) {
                          errorMessages.push(value);
                        }
                      }
                    })
                    if (errorMessages) {
                      alert(`作成に失敗しました。もう一度お試しください。\n${errorMessages[0]}`);
                    }
                    errorMessages = []
                  }
                })
                .catch(error => {
                  console.log(JSON.parse(error));
                  if (error) {
                    alert('接続エラーが発生しました。');
                  }
                })
              ) : (
                // 新規作成時のデータ送信
                axios.post('/api/v1/jobs', sendData)
                .then(res => {
                  const valid_flag = JSON.parse(res.data.valid_flag)
                  // 作成に成功
                  if (valid_flag) {
                    console.log(res.data.data)
                    toast.success('求人の作成に成功しました。')
                    navigate('/admins/jobs');
                  // 作成に失敗（バリデーションエラー）
                  } else {
                    JSON.parse(res.data.errors, function (key, value) {
                      if(key) {
                        if(!Array.isArray(value)) {
                          errorMessages.push(value);
                        }
                      }
                    })
                    if (errorMessages) {
                      alert(`作成に失敗しました。もう一度お試しください。\n${errorMessages[0]}`);
                    }
                    errorMessages = []
                  }
                })
                .catch(error => {
                  console.log(JSON.parse(error));
                  if (error) {
                    alert('接続エラーが発生しました。');
                  }
                })
              )}
            })}
          >
            {/* PRフラグ */}
            <div className="admin-form__group">
              <div className="admin-form__group-label">
                <label className="admin-form__group-label--letter">PR求人</label>
              </div>
              <div className="mt-3">
                <label>
                  <input
                    {...register("pr_flag")}
                    type="checkbox"
                    className="ms-3 mb-3"
                    value={1}
                  />
                  <span className="ms-2">
                    PR求人の場合はチェック
                  </span>
                </label>
              </div>
            </div>
            {/* 企業名 */}
            <div className='admin-form__group'>
              <div className='admin-form__group-label'>
                <label className='admin-form__group-label--letter'>企業名</label>
                <div className='admin-form__group-label--required'>必須</div>
              </div>
              <input className='admin-form__group-input'
                {...register('company_name', {
                  required: '必ず入力してください',
                  maxLength: { value: 137, message: '137文字以下で入力してください。'}
                })}
              />
              <label>
                <Controller
                  name="display_company_name_flag"
                  control={control}
                  defaultValue={isEditMode ? (currentJob?.display_company_name_flag) : true}
                  render={({ field }) => (
                    <input
                      type="checkbox"
                      className="ms-3 mb-3"
                      // field.value が boolean であることを期待
                      checked={field.value} // field.value を boolean に変換して checked に渡す
                      onChange={(e) => field.onChange(e.target.checked)} // チェック状態を渡す
                      ref={field.ref}
                    />
                  )}
                />
                  {/* <input
                    {...register("display_company_name_flag")}
                    type="checkbox"
                    checked={currentJob ? currentJob.display_company_name_flag : true}
                    className="ms-3 mb-3"
                    value={"1"}
                  /> */}
                <span className="ms-2">
                  企業名を表示する
                </span>
              </label>

              <div className='admin-form__group-error'>{errors.company_name?.message}</div>
            </div>
            {/* 電話番号 */}
            <div className='admin-form__group'>
              <div className='admin-form__group-label'>
                <label className='admin-form__group-label--letter'>電話番号</label>
                <div className='admin-form__group-label--required'>必須</div>
              </div>
              <input className='admin-form__group-input'
                {...register('phone_number', {
                  required: '必ず入力してください',
                  minLength: { value: 10, message: '電話番号を正しく入力してください。' },
                  maxLength: { value: 15, message: '電話番号が長すぎます。' }
                })}
              />
              <div className='admin-form__group-error'>{errors.phone_number?.message}</div>
            </div>
            {/* 掲載最終日 */}
            <div className='admin-form__group'>
              <div className='admin-form__group-label'>
                <label className='admin-form__group-label--letter'>掲載最終日</label>
                <div className='admin-form__group-label--required'>必須</div>
              </div>
              <input type='date' className='admin-form__group-input'
                {...register('closing_date', { required: '必ず入力してください' })}
              />
              <div className='admin-form__group-error'>{errors.closing_date?.message}</div>
            </div>
            {/* 掲載用企業写真 */}
            <div className='admin-form__group'>
              <div className='admin-form__group-label'>
                <label className='admin-form__group-label--letter'>掲載用企業写真</label>
                <div className='admin-form__group-label--required'>必須</div>
              </div>
              <div className='mt-3 d-flex justify-content-left align-items-center'>
                {imagePath && <img src={imagePath} className='ms-2' width='173' height='115' />}
                <div className='ms-4'>
                  {/* 隠されたアップロードボタン */}
                  <input
                    type="file"
                    accept=".jpg, .jpeg, .png"
                    style={{ display: 'none' }}
                    { ...register('company_image', {
                      // 編集画面の時は入力必須にしない
                      required: isEditMode ? false : '必ずアップロードしてください。',
                      validate: {
                        fileType: (files) => {
                          if (files && files[0]) {
                            const validTypes = [
                              'image/jpeg',
                              'image/png',
                            ];
                            if (!validTypes.includes(files[0].type)) {
                              return 'アップロードできるのはPNG,JPG,JPEGの画像のみです。';
                            }
                          }
                          return true;
                        },
                        fileSize: (files) => {
                          if (files && files[0]) {
                            if (files[0].size > (1024*1024) * 5) {
                              return '5MB以下のファイルをアップロードしてください。';
                            }
                          }
                          return true;
                        }
                      },
                    })}
                    onChange={handleFileChange}
                    ref={(e) => {inputRef.current = e}}
                  />
                  {/* 表示されるアップロードボタン */}
                  <button
                    type='button'
                    className='admin-form__group-upload-btn'
                    onClick={uploadClick}
                  >
                    <span className="material-symbols-outlined">
                      upload
                    </span>
                    アップロード
                  </button>
                </div>
              </div>
              <div className='admin-form__group-error'>{errors.company_image?.message}</div>
            </div>
            {/* キャッチコピー */}
            <div className='admin-form__group'>
              <div className='admin-form__group-label'>
                <label className='admin-form__group-label--letter'>キャッチコピー</label>
                <div className='admin-form__group-label--required'>必須</div>
              </div>
              <textarea className='admin-form__group-input-lg'
                {...register('catch_copy', {
                  required: '必ず入力してください',
                  maxLength: { value: 255, message: '255文字以下で入力してください。'}
                })}
              />
              <div className='admin-form__group-error'>{errors.catch_copy?.message}</div>
            </div>
            {/* 募集職種 */}
            <div className='admin-form__group'>
              <div className='admin-form__group-label'>
                <label className='admin-form__group-label--letter'>募集職種</label>
                <div className='admin-form__group-label--required'>必須</div>
              </div>
              {fields.map((field, index) => (
                <div className='d-flex justify-content-left' key={field.id}>
                  <div>
                    <select className='admin-form__group-select' {...register(`position.${index}.id`, { required: '必ず選択してください' })}>
                      <option value=''>選択してください</option>
                      { positions.map ( position =>
                        <option value={position.id}>{position.name}</option>
                      )}
                    </select>
                    <ErrorMessage
                      errors={errors}
                      name={`position.${index}.id`}
                      as="div"
                      className='admin-form__group-error'
                    />
                  </div>
                  <div>
                    <button
                      type="button"
                      className='admin-form__group-btn-delete'
                      onClick={() => remove(index)}
                    >
                      削除
                    </button>
                  </div>
                </div>
              ))}
              <div className='admin-form__group-container'>
                <button
                  type="button"
                  className='admin-form__group-btn-add'
                  onClick={() => append({id: null})}
                >
                  <span className="material-symbols-outlined">
                    add
                  </span>
                  職種を追加
                </button>
              </div>
            </div>
            {/* 業種 */}
            <div className='admin-form__group'>
              <div className='admin-form__group-label'>
                <label className='admin-form__group-label--letter'>業種</label>
                <div className='admin-form__group-label--required'>必須</div>
              </div>
              <select className='admin-form__group-select' {...register('industry_id', { required: '必ず選択してください' })}>
                <option value=''>選択してください</option>
                { industries.map ( industry =>
                  <option value={industry.id}>{industry.name}</option>
                )}
              </select>
              <div className='admin-form__group-error'>{errors.industry_id?.message}</div>
            </div>
            {/* 給与 */}
            <div className="admin-form__group">
              <div className="admin-form__group-label">
                <label className="admin-form__group-label--letter">給与</label>
                <div className="admin-form__group-label--required">必須</div>
              </div>
              <input type="text" className="admin-form__group-input"
                {...register('salary', {
                  required: '必ず入力してください',
                  maxLength: { value: 255, message: '255文字以下で入力してください。'}
                })}
              />
              <div className="admin-form__group-error">{errors.salary?.message}</div>
            </div>
            {/* 地域 */}
            {/* <div className="admin-form__group">
              <div className="admin-form__group-label">
                <label className="admin-form__group-label--letter">地域</label>
                <div className="admin-form__group-label--required">必須</div>
              </div>

              <Controller
                name="area_id"
                control={control}
                rules={{ required: "必ず選択してください" }}
                render={({ field }) => {
                  const selectOptions = areas.map(area => ({
                    value: area.id,
                    label: `${area.name}/${area.prefecture}`
                  }));

                  // field.value (ID) に基づいて、選択されているオプションオブジェクトを見つける
                  const currentValue = selectOptions.find(option => option.value === field.value);
                  return (
                    <Select
                      ref={field.ref}
                      name={field.name}
                      onBlur={field.onBlur}
                      options={selectOptions}
                      value={currentValue}
                      isSearchable={true}
                      styles={customSelectStylesForJobForm}
                      className="admin-form__group-select--searchable"
                      placeholder="選択してください"
                      onChange={(selectedOption) => field.onChange(selectedOption ? selectedOption.value : null)}
                    />
                  );
                }}
              />
              <div className="admin-form__group-error">{errors.area_id?.message}</div>
            </div> */}
            {/* 日本語レベル */}
            <div className="admin-form__group">
              <div className="admin-form__group-label">
                <label className="admin-form__group-label--letter">日本語レベル</label>
                <div className="admin-form__group-label--required">必須</div>
              </div>
              <select className="admin-form__group-select" {...register("japanese_level", { required: "必ず選択してください" })}>
                <option value="">選択してください</option>
                <option value="n1">ネイティブレベル（N1相当）</option>
                <option value="n2">ビジネス会話レベル（N2相当）</option>
                <option value="n3">日常会話レベル（N3相当）</option>
                <option value="n4">簡単な会話ができるレベル（N4相当）</option>
                <option value="n5">自己紹介・挨拶レベル（N5相当）</option>
              </select>
              <div className="admin-form__group-error">{errors.japanese_level?.message}</div>
            </div>
            {/* タグ */}
            <div className="admin-form__group">
              <div className="admin-form__group-label">
                <label className="admin-form__group-label--letter">タグ</label>
              </div>
              <div className="mt-3">
                { tags.map( tag =>
                  <label>
                    <input
                      type="checkbox"
                      value={tag.id}
                      className="ms-3 mb-3"
                      {...register("tag")}
                    />
                    <span className="ms-2">{tag.name}</span>
                  </label>
                )}
              </div>
              <div className="admin-form__group-error">{errors.tag?.message}</div>
            </div>
            {/* アピールポイント */}
            <div className="admin-form__group">
              <div className="admin-form__group-label">
                <label className="admin-form__group-label--letter">アピールポイント</label>
                <div className="admin-form__group-label--required">必須</div>
              </div>
              <textarea className="d-flex admin-form__group-input-lg"
                {...register("appeal_point", {
                  required: "必ず入力してください",
                  maxLength: { value: 2000, message: '2000文字以下で入力してください。'}
                })}
              />
              <div className="admin-form__group-error">{errors.appeal_point?.message}</div>
            </div>
            {/* 雇用形態 */}
            <div className="admin-form__group">
              <div className="admin-form__group-label">
                <label className="admin-form__group-label--letter">雇用形態</label>
                <div className="admin-form__group-label--required">必須</div>
              </div>
              <select
                className="admin-form__group-select"
                {...register('employment_type', { required: "必ず選択してください" })}
                onChange={(e)=>setEmploymentType(e.target.value)}
              >
                <option value="full_time">正社員</option>
                <option value="part_time">アルバイト</option>
              </select>
              <div className="admin-form__group-error">{errors.employment_type?.message}</div>
            </div>
            {/* 要求ビザ種目 */}
            <div className="admin-form__group">
              <div className="admin-form__group-label">
                <label className="admin-form__group-label--letter">要求ビザ種目</label>
                <div className="admin-form__group-label--required">必須</div>
              </div>
              <div className="mt-3">
                { isEditMode ? (
                  employmentType === 'full_time' ? (
                    <>
                      <div>
                        <input type="radio" id="tech" value="tech" className="admin-form__group-radio-button" {...register("visa_type")}/>
                        <label htmlFor="tech" className="admin-form__group-radio-label">技術・人文知識・国際業務</label>
                      </div>
                      <div>
                        <input type="radio" id="skill" value="skill" className="admin-form__group-radio-button" {...register("visa_type")}/>
                        <label htmlFor="skill" className="admin-form__group-radio-label">特定技能</label>
                      </div>
                      <div>
                        <input type="radio" id="either_way" value="either_way" className="admin-form__group-radio-button" {...register("visa_type")}/>
                        <label htmlFor="either_way" className="admin-form__group-radio-label">どちらでも構わない</label>
                      </div>
                    </>
                  ) : (
                    <>
                      <div>
                        <input type="radio" id="student" value="student" className="admin-form__group-radio-button" {...register("visa_type")}/>
                        <label htmlFor="student" className="admin-form__group-radio-label">留学ビザ、家族滞在</label>
                      </div>
                      <div>
                        <input type="radio" id="other" value="other" className="admin-form__group-radio-button" {...register("visa_type")}/>
                        <label htmlFor="other" className="admin-form__group-radio-label">その他</label>
                      </div>
                    </>
                  )
                ) : (
                  employmentType === 'full_time' ? (
                    <>
                      <div>
                        <input type="radio" id="tech" value="tech" className="admin-form__group-radio-button" defaultChecked={true} {...register("visa_type")}/>
                        <label htmlFor="tech" className="admin-form__group-radio-label">技術・人文知識・国際業務</label>
                      </div>
                      <div>
                        <input type="radio" id="skill" value="skill" className="admin-form__group-radio-button" {...register("visa_type")}/>
                        <label htmlFor="skill" className="admin-form__group-radio-label">特定技能</label>
                      </div>
                      <div>
                        <input type="radio" id="either_way" value="either_way" className="admin-form__group-radio-button" {...register("visa_type")}/>
                        <label htmlFor="either_way" className="admin-form__group-radio-label">どちらでも構わない</label>
                      </div>
                    </>
                  ) : (
                    <>
                      <div>
                        <input type="radio" id="student" value="student" className="admin-form__group-radio-button" {...register("visa_type")}/>
                        <label htmlFor="student" className="admin-form__group-radio-label">留学ビザ、家族滞在</label>
                      </div>
                      <div>
                        <input type="radio" id="other" value="other" className="admin-form__group-radio-button" {...register("visa_type")}/>
                        <label htmlFor="other" className="admin-form__group-radio-label">その他</label>
                      </div>
                    </>
                  )
                )}
              </div>
              <div className="admin-form__group-error">{errors.visa_type?.message}</div>
            </div>
            {/* 勤務時間 */}
            <div className="admin-form__group">
              <div className="admin-form__group-label">
                <label className="admin-form__group-label--letter">勤務時間</label>
                <div className="admin-form__group-label--required">必須</div>
              </div>
              <textarea className="d-flex admin-form__group-input-lg"
                {...register("working_hours", {
                  required: "必ず入力してください",
                  maxLength: { value: 2000, message: '2000文字以下で入力してください。'}
                })}
              />
              <div className="admin-form__group-error">{errors.working_hours?.message}</div>
            </div>
            {/* 試用期間 */}
            <div className="admin-form__group">
              <div className="admin-form__group-label">
                <label className="admin-form__group-label--letter">試用期間</label>
                <div className="admin-form__group-label--required">必須</div>
              </div>
              <textarea className="d-flex admin-form__group-input-lg"
                {...register("probation_period", {
                  required: "必ず入力してください",
                  maxLength: { value: 255, message: '255文字以下で入力してください。'}
                })}
              />
              <div className="admin-form__group-error">{errors.probation_period?.message}</div>
            </div>
            {/* 郵便番号 */}
            <div className="admin-form__group">
              <div className="admin-form__group-label">
                <label className="admin-form__group-label--letter">郵便番号(ハイフンなし)</label>
                <div className="admin-form__group-label--required">必須</div>
              </div>
              <input className="admin-form__group-input"
                {...register("postal_code", {
                  required: "必ず入力してください",
                  minLength: { value: 7, message: '7文字で入力してください。'},
                  maxLength: { value: 7, message: '7文字で入力してください。'}
                })}
              />
              <div className='admin-form__group-error'>{errors.postal_code?.message}</div>
            </div>
            {/* 都道府県 */}
            <div className="admin-form__group">
              <div className="admin-form__group-label">
                <label className="admin-form__group-label--letter">都道府県</label>
                <div className="admin-form__group-label--required">必須</div>
              </div>
              <Controller
                name="prefecture_id"
                control={control}
                rules={{ required: "必ず選択してください" }}
                render={({ field }) => {
                  return (
                    <Select<SelectOptionType>
                      ref={field.ref}
                      name={field.name}
                      onBlur={field.onBlur}
                      options={prefectureOptions}
                      value={prefectureOption}
                      isSearchable={true}
                      styles={customSelectStylesForJobForm}
                      className="admin-form__group-select--searchable"
                      onChange={(selectedOption) => {
                        if (selectedOption && selectedOption.value) {
                          field.onChange(selectedOption.value)
                          setPrefectureOption(selectedOption)
                          updateCityOptions(selectedOption.value)
                          setValue('city_id', null)
                        } else {
                          setCityOptions([defaultCityOption])
                        }
                      }}
                    />
                  )
                }}
              />
              <div className='admin-form__group-error'>{errors.prefecture_id?.message}</div>
            </div>
            {/* 市区町村 */}
            <div className="admin-form__group">
              <div className="admin-form__group-label">
                <label className="admin-form__group-label--letter">市区町村</label>
                <div className="admin-form__group-label--required">必須</div>
              </div>
              <Controller
                name="city_id"
                control={control}
                rules={{ required: "必ず選択してください" }}
                render={({ field }) => {
                  return (
                    <Select<SelectOptionType>
                      ref={field.ref}
                      name={field.name}
                      onBlur={field.onBlur}
                      options={cityOptions}
                      value={cityOption}
                      isSearchable={true}
                      styles={customSelectStylesForJobForm}
                      className="admin-form__group-select--searchable"
                      isLoading={loadingCities}
                      onChange={(selectedOption) => {
                        if (selectedOption) {
                          field.onChange(selectedOption.value)
                          setCityOption(selectedOption)
                        } else {
                          setCityOptions([defaultCityOption])
                        }
                      }}
                    />
                  )
                }}
              />
              <div className='admin-form__group-error'>{errors.city_id?.message}</div>
            </div>
            {/* 番地 */}
            <div className="admin-form__group">
              <div className="admin-form__group-label">
                <label className="admin-form__group-label--letter">番地</label>
              </div>
              <input className="admin-form__group-input"
                {...register("address", {
                  maxLength: { value: 255, message: '255文字以下で入力してください。'}
                })}
              />
              <div className='admin-form__group-error'>{errors.address?.message}</div>
            </div>
            {/* ビル名・部屋番号 */}
            <div className="admin-form__group">
              <div className="admin-form__group-label">
                <label className="admin-form__group-label--letter">ビル名・部屋番号</label>
              </div>
              <input className="admin-form__group-input"
                {...register("building_name", {
                  maxLength: { value: 255, message: '255文字以下で入力してください。'}
                })}
              />
              <div className='admin-form__group-error'>{errors.building_name?.message}</div>
            </div>
            {/* 交通費 */}
            <div className="admin-form__group">
              <div className="admin-form__group-label">
                <label className="admin-form__group-label--letter">交通費</label>
                <div className="admin-form__group-label--required">必須</div>
              </div>
              <textarea className="admin-form__group-input-lg"
                {...register("transportation_fee", {
                  required: "必ず入力してください",
                  maxLength: { value: 255, message: '255文字以下で入力してください。'}
                })}
              />
              <div className='admin-form__group-error'>{errors.transportation_fee?.message}</div>
            </div>
            {/* 休日 */}
            <div className="admin-form__group">
              <div className="admin-form__group-label">
                <label className="admin-form__group-label--letter">休日</label>
                <div className="admin-form__group-label--required">必須</div>
              </div>
              <textarea className="d-flex admin-form__group-input-lg"
                {...register("holidays", {
                  required: "必ず入力してください",
                  maxLength: { value: 255, message: '255文字以下で入力してください。'}
                })}
              />
              <div className='admin-form__group-error'>{errors.holidays?.message}</div>
            </div>
            {/* 時間外労働 */}
            <div className="admin-form__group">
              <div className="admin-form__group-label">
                <label className="admin-form__group-label--letter">時間外労働</label>
                <div className="admin-form__group-label--required">必須</div>
              </div>
              { isEditMode ? (
                <div className="mt-3">
                  <div>
                    <input type="radio" id="true" value="yes" className="admin-form__group-radio-button" {...register("overtime")} />
                    <label htmlFor="true" className="admin-form__group-radio-label" >あり</label>
                  </div>
                  <div>
                    <input type="radio" id="false" value="no" className="admin-form__group-radio-button" {...register("overtime")} />
                    <label htmlFor="false" className="admin-form__group-radio-label" >なし</label>
                  </div>
                </div>
              ) : (
                <div className="mt-3">
                  <div>
                    <input type="radio" id="true" value="yes" className="admin-form__group-radio-button" defaultChecked={true} {...register("overtime")} />
                    <label htmlFor="true" className="admin-form__group-radio-label" >あり</label>
                  </div>
                  <div>
                    <input type="radio" id="false" value="no" className="admin-form__group-radio-button" {...register("overtime")} />
                    <label htmlFor="false" className="admin-form__group-radio-label" >なし</label>
                  </div>
                </div>
              )}
            </div>
            {/* 給与昇給基準 */}
            <div className="admin-form__group">
              <div className="admin-form__group-label">
                <label className="admin-form__group-label--letter">給与昇給基準</label>
                <div className="admin-form__group-label--required">必須</div>
              </div>
              <input className="admin-form__group-input"
                {...register("salary_increase_criteria", {
                  required: "必ず入力してください",
                  maxLength: { value: 255, message: '255文字以下で入力してください。'}
                })}
              />
              <div className='admin-form__group-error'>{errors.salary_increase_criteria?.message}</div>
            </div>
            {/* 加入保険 */}
            <div className="admin-form__group">
              <div className="admin-form__group-label">
                <label className="admin-form__group-label--letter">加入保険</label>
                <div className="admin-form__group-label--required">必須</div>
              </div>
              <input className="admin-form__group-input"
                {...register("insurance", {
                  required: "必ず入力してください",
                  maxLength: { value: 255, message: '255文字以下で入力してください。'}
                })}
              />
              <div className='admin-form__group-error'>{errors.insurance?.message}</div>
            </div>
            {/* その他特典 */}
            <div className="admin-form__group">
              <div className="admin-form__group-label">
                <label className="admin-form__group-label--letter">その他特典</label>
              </div>
              <textarea className="d-flex admin-form__group-input-lg"
                {...register("benefits", {
                  maxLength: { value: 2000, message: '2000文字以下で入力してください。'}
                })}
              />
              <div className='admin-form__group-error'>{errors.benefits?.message}</div>
            </div>
            {/* 在留資格 */}
            <div className="admin-form__group">
              <div className="admin-form__group-label">
                <label className="admin-form__group-label--letter">在留資格</label>
                <div className="admin-form__group-label--required">必須</div>
              </div>
              { isEditMode ? (
                <div className="mt-3">
                  <div>
                    <input type="radio" id="necessary" value="need" className="admin-form__group-radio-button" {...register("residence_permit")} />
                    <label htmlFor="necessary" className="admin-form__group-radio-label">必要</label>
                  </div>
                  <div>
                    <input type="radio" id="unnecessary" value="no_need" className="admin-form__group-radio-button" {...register("residence_permit")} />
                    <label htmlFor="unnecessary" className="admin-form__group-radio-label">不要</label>
                  </div>
                </div>
              ) : (
                <div className="mt-3">
                  <div>
                    <input type="radio" id="necessary" value="need" className="admin-form__group-radio-button" defaultChecked={true} {...register("residence_permit")} />
                    <label htmlFor="necessary" className="admin-form__group-radio-label">必要</label>
                  </div>
                  <div>
                    <input type="radio" id="unnecessary" value="no_need" className="admin-form__group-radio-button" {...register("residence_permit")} />
                    <label htmlFor="unnecessary" className="admin-form__group-radio-label">不要</label>
                  </div>
                </div>
              )}
            </div>
            {/* 面接方法 */}
            <div className="admin-form__group">
              <div className="admin-form__group-label">
                <label className="admin-form__group-label--letter">面接方法</label>
                <div className="admin-form__group-label--required">必須</div>
              </div>
              { isEditMode ? (
                <div className="mt-3">
                  <div>
                    <input type="radio" id="offline" value="offline" className="admin-form__group-radio-button" {...register("interview_method")} />
                    <label htmlFor="offline" className="admin-form__group-radio-label">直接面接</label>
                  </div>
                  <div>
                    <input type="radio" id="online" value="online" className="admin-form__group-radio-button" {...register("interview_method")} />
                    <label htmlFor="online" className="admin-form__group-radio-label">オンライン面接</label>
                  </div>
                </div>
              ) : (
                <div className="mt-3">
                  <div>
                    <input type="radio" id="offline" value="offline" className="admin-form__group-radio-button" defaultChecked={true} {...register("interview_method")} />
                    <label htmlFor="offline" className="admin-form__group-radio-label">直接面接</label>
                  </div>
                  <div>
                    <input type="radio" id="online" value="online" className="admin-form__group-radio-button" {...register("interview_method")} />
                    <label htmlFor="online" className="admin-form__group-radio-label">オンライン面接</label>
                  </div>
                </div>
              )}
            </div>
            {/* 職場環境／雰囲気 */}
            <div className="admin-form__group">
              <div className="admin-form__group-label">
                <div className="admin-form__group-label--letter">職場環境 / 雰囲気</div>
                <div className="admin-form__group-label--required">必須</div>
              </div>
              <div className='mt-3'>
                <label className="admin-form__group-label--letter ms-2">多い年齢層</label>
              </div>
              { isEditMode ? (
                <div className='admin-form__group-progress-bar'>
                  <input className="" type="radio" value='teen' {...register("work_environment_age")} />
                  <input className="" type="radio" value='twenties' {...register("work_environment_age")} />
                  <input className="" type="radio" value='thirties' {...register("work_environment_age")} />
                  <input className="" type="radio" value='forties' {...register("work_environment_age")} />
                  <input className="" type="radio" value='fifties' {...register("work_environment_age")} />
                  <input className="" type="radio" value='sixties' {...register("work_environment_age")} />
                </div>
              ) : (
                <div className='admin-form__group-progress-bar'>
                  <input className="" type="radio" value='teen' defaultChecked={true} {...register("work_environment_age")} />
                  <input className="" type="radio" value='twenties' {...register("work_environment_age")} />
                  <input className="" type="radio" value='thirties' {...register("work_environment_age")} />
                  <input className="" type="radio" value='forties' {...register("work_environment_age")} />
                  <input className="" type="radio" value='fifties' {...register("work_environment_age")} />
                  <input className="" type="radio" value='sixties' {...register("work_environment_age")} />
                </div>
              )}
              <div className='admin-form__group-progress-label'>
                <div>10代</div>
                <div>20代</div>
                <div>30代</div>
                <div>40代</div>
                <div>50代</div>
                <div>60代</div>
              </div>
              <div className='admin-form__group-error'>{errors.work_environment_age?.message}</div>
            </div>
            {/* 男女の割合 */}
            <div className="admin-form__group">
              <div>
                <label className="admin-form__group-label--letter ms-2">男女の割合</label>
              </div>
              { isEditMode ? (
                <div className='admin-form__group-progress-bar'>
                  <input className="" type="radio" value='man' {...register("work_environment_gender")} />
                  <input className="" type="radio" value='slightly_man' {...register("work_environment_gender")} />
                  <input className="" type="radio" value='same' {...register("work_environment_gender")} />
                  <input className="" type="radio" value='slightly_woman' {...register("work_environment_gender")} />
                  <input className="" type="radio" value='woman' {...register("work_environment_gender")} />
                </div>
              ) : (
                <div className='admin-form__group-progress-bar'>
                  <input className="" type="radio" value='man' defaultChecked={true} {...register("work_environment_gender")} />
                  <input className="" type="radio" value='slightly_man' {...register("work_environment_gender")} />
                  <input className="" type="radio" value='same' {...register("work_environment_gender")} />
                  <input className="" type="radio" value='slightly_woman' {...register("work_environment_gender")} />
                  <input className="" type="radio" value='woman' {...register("work_environment_gender")} />
                </div>
              )}
              <div className='admin-form__group-progress-label'>
                <div>男性</div>
                <div>女性</div>
              </div>
              <div className='admin-form__group-error'>{errors.work_environment_gender?.message}</div>
            </div>
            {/* 外国人が働いている割合 */}
            <div className="admin-form__group">
              <div>
                <label className="admin-form__group-label--letter ms-2">外国人が働いている割合</label>
              </div>
              { isEditMode ? (
                <div className='admin-form__group-progress-bar'>
                  <input className="" type="radio" value='many' {...register("work_environment_foreign_ratio")} />
                  <input className="" type="radio" value='slightly_many' {...register("work_environment_foreign_ratio")} />
                  <input className="" type="radio" value='same' {...register("work_environment_foreign_ratio")} />
                  <input className="" type="radio" value='slightly_few' {...register("work_environment_foreign_ratio")} />
                  <input className="" type="radio" value='few' {...register("work_environment_foreign_ratio")} />
                </div>
              ) : (
                <div className='admin-form__group-progress-bar'>
                  <input className="" type="radio" value='many' defaultChecked={true} {...register("work_environment_foreign_ratio")} />
                  <input className="" type="radio" value='slightly_many' {...register("work_environment_foreign_ratio")} />
                  <input className="" type="radio" value='same' {...register("work_environment_foreign_ratio")} />
                  <input className="" type="radio" value='slightly_few' {...register("work_environment_foreign_ratio")} />
                  <input className="" type="radio" value='few' {...register("work_environment_foreign_ratio")} />
                </div>
              )}
              <div className='admin-form__group-progress-label-m'>
                <div className="ms-2">多い</div>
                <div>少ない</div>
              </div>
              <div className='admin-form__group-error'>{errors.work_environment_foreign_ratio?.message}</div>
            </div>
            {/* 英語または母国語を活かせる環境 */}
            <div className="admin-form__group">
              <div>
                <label className="admin-form__group-label--letter ms-2">英語または母国語を活かせる環境</label>
              </div>
              { isEditMode ? (
                <div className='admin-form__group-progress-bar'>
                  <input className="" type="radio" value='many' {...register("work_environment_language")} />
                  <input className="" type="radio" value='slightly_many' {...register("work_environment_language")} />
                  <input className="" type="radio" value='same' {...register("work_environment_language")} />
                  <input className="" type="radio" value='slightly_few' {...register("work_environment_language")} />
                  <input className="" type="radio" value='few' {...register("work_environment_language")} />
                </div>
              ) : (
                <div className='admin-form__group-progress-bar'>
                  <input className="" type="radio" value='many' defaultChecked={true} {...register("work_environment_language")} />
                  <input className="" type="radio" value='slightly_many' {...register("work_environment_language")} />
                  <input className="" type="radio" value='same' {...register("work_environment_language")} />
                  <input className="" type="radio" value='slightly_few' {...register("work_environment_language")} />
                  <input className="" type="radio" value='few' {...register("work_environment_language")} />
                </div>
              )}
              <div className='admin-form__group-progress-label-m'>
                <div className="ms-2">多い</div>
                <div>少ない</div>
              </div>
              <div className='admin-form__group-error'>{errors.work_environment_language?.message}</div>
            </div>
            {/* 外国人の採用経験 */}
            <div className="admin-form__group">
              <div>
                <label className="admin-form__group-label--letter ms-2">外国人の採用経験</label>
              </div>
              { isEditMode ? (
                <div className='admin-form__group-progress-bar'>
                  <input className="" type="radio" value='no_have' {...register("work_environment_hiring_exp")} />
                  <input className="" type="radio" value='have' {...register("work_environment_hiring_exp")} />
                </div>
              ) : (
                <div className='admin-form__group-progress-bar'>
                  <input className="" type="radio" value='no_have' defaultChecked={true} {...register("work_environment_hiring_exp")} />
                  <input className="" type="radio" value='have' {...register("work_environment_hiring_exp")} />
                </div>
              )}
              <div className='admin-form__group-progress-label'>
                <div>なし</div>
                <div>あり</div>
              </div>
              <div className='admin-form__group-error'>{errors.work_environment_hiring_exp?.message}</div>
            </div>
            {/* 日本語を使う頻度 */}
            <div className="admin-form__group">
              <div>
                <label className="admin-form__group-label--letter ms-2">日本語を使う頻度</label>
              </div>
              { isEditMode ? (
                <div className='admin-form__group-progress-bar'>
                  <input className="" type="radio" value='many' {...register("work_environment_japanese_freq", { required: "必ず選択してください" })} />
                  <input className="" type="radio" value='slightly_many' {...register("work_environment_japanese_freq", { required: "必ず選択してください" })} />
                  <input className="" type="radio" value='same' {...register("work_environment_japanese_freq", { required: "必ず選択してください" })} />
                  <input className="" type="radio" value='slightly_few' {...register("work_environment_japanese_freq", { required: "必ず選択してください" })} />
                  <input className="" type="radio" value='few' {...register("work_environment_japanese_freq", { required: "必ず選択してください" })} />
                </div>
              ) : (
                <div className='admin-form__group-progress-bar'>
                  <input className="" type="radio" value='many' defaultChecked={true} {...register("work_environment_japanese_freq", { required: "必ず選択してください" })} />
                  <input className="" type="radio" value='slightly_many' {...register("work_environment_japanese_freq", { required: "必ず選択してください" })} />
                  <input className="" type="radio" value='same' {...register("work_environment_japanese_freq", { required: "必ず選択してください" })} />
                  <input className="" type="radio" value='slightly_few' {...register("work_environment_japanese_freq", { required: "必ず選択してください" })} />
                  <input className="" type="radio" value='few' {...register("work_environment_japanese_freq", { required: "必ず選択してください" })} />
                </div>
              )}
              <div className='admin-form__group-progress-label-m'>
                <div className="ms-2">多い</div>
                <div>少ない</div>
              </div>
              <div className='admin-form__group-error'>{errors.work_environment_japanese_freq?.message}</div>
            </div>
            {/* 送信ボタン */}
            <div className='d-flex justify-content-center mb-3'>
              <button type='submit' className='admin-form__btn'>
                { isEditMode ? '更新する' : '保存する'}
              </button>
            </div>
          </form>
          {/* <button type='button' onClick={setJob}>仮の入力値セット</button> */}
        </div>
      </div>
    </div>
  );
}
